import * as React from 'react';

export default function IconNoInternet() {
  return (
    <svg width="120" height="120" fill="none">
      <path
        d="M21 43.27l-4-4.4M33 24.21c1.29 3.44-.38-.96-5-13.21M36 34l5.3 14.74"
        stroke="#E8E8E8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M48 105l17.33-73 18.17 72.5-35.5.5z" fill="#E8E8E8" />
      <path
        d="M86.73 57l9.77-12M102 39.27l4-4.4M90 20.21c-1.29 3.44.38-.96 5-13.21M87 30l-5.3 14.74"
        stroke="#E8E8E8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M43 104.5L60 32l18.42 72.5"
        stroke="#BDBDBD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72 83L53 63h13.88"
        stroke="#BDBDBD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M67.16 64L48 83h24M57 51.5h7"
        stroke="#BDBDBD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.67 91h-.17a10.5 10.5 0 113.06-20.55A12.5 12.5 0 0145.9 75H46a8 8 0 11-.06 16H19.67v0z"
        fill="#fff"
        stroke="#BDBDBD"
        strokeWidth="2"
      />
      <path
        d="M74.17 10.89A19.94 19.94 0 0060 5a19.94 19.94 0 00-14.14 5.86M68.16 16.91A12.96 12.96 0 0060 14c-3.04 0-5.85 1.07-8.13 2.9"
        stroke="#BDBDBD"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path d="M60 26a3 3 0 100-6 3 3 0 000 6z" fill="#BDBDBD" />
      <path
        d="M78.67 114h-.17a10.5 10.5 0 113.06-20.55A12.5 12.5 0 01104.9 98h.09a8 8 0 010 16H78.67v0z"
        fill="#fff"
        stroke="#BDBDBD"
        strokeWidth="2"
      />
    </svg>
  );
}
